import { HStack, Text } from '@chakra-ui/react';

import { Navbar } from '@/components/DayPicker/_partials/Navbar';

import { useYearContext } from './YearContext';

export const MonthCaption = () => {
  const { year, setYear } = useYearContext();

  const handlePreviousClick = () => setYear((prevYear) => prevYear - 1);
  const handleNextClick = () => setYear((prevYear) => prevYear + 1);

  return (
    <HStack py={3} justifyContent="space-between">
      <Navbar onPreviousClick={handlePreviousClick} />
      <Text fontWeight="500" color="gray.700" fontSize="md">
        {year}
      </Text>
      <Navbar onNextClick={handleNextClick} />
    </HStack>
  );
};
